import { http } from 'http';

export default {
  uploadImages: ({ idVehicle, images }) =>
    http.post('/VehicleImages/update/vehicle', {
      idVehicle,
      images
    }),

  updateCampaignImages: ({ campaignId, images }) =>
    http.post('/VehicleImages/update/campaign', {
      campaignId,
      images
    }),

  updateMassive: ({ campaignIds, images }) =>
    http.post('/VehicleImages/update/masive', {
      campaignIds,
      images
    })
};
